<template>
    <div class="main">
        <c-panel :title="edit ? 'EDITAR CONCEITO' : 'NOVO CONCEITO'" titleIcon="fas fa-edit">
            <el-form label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Grupo de Conceito" prop="grupo_conceito_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.grupo_conceito_id" filterable>
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Descrição" prop="descricao" :rules="[$requiredBlur]">
                            <el-input v-model="dados.descricao"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Ordem">
                            <el-input-number v-model="dados.ordem" :min="0" :step="1"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

                <c-panel title="ITENS DO CONCEITO" titleIcon="fas fa-list-ul">
                    <div style="color: #909399; font-size: 12px; margin-bottom: 10px;">
                        Cada item representa um valor possível (ex.: Ótimo, Bom, Regular, Insuficiente). Os professores selecionam um destes ao lançar o conceito do aluno.
                    </div>
                    <el-row :gutter="10" v-for="(it, idx) in dados.itens" :key="idx" class="u-mb-10">
                        <el-col :xs="24" :sm="6">
                            <el-input v-model="it.v" placeholder="Chave (ex.: otimo)" maxlength="40"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="10">
                            <el-input v-model="it.l" placeholder="Rótulo exibido (ex.: Ótimo)"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <el-select v-model="it.resultado" clearable placeholder="Resultado (aprova/reprova)" style="width: 100%;">
                                <el-option v-for="op in resultadosConceito" :key="op.v" :label="op.l" :value="op.v"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="2">
                            <el-button @click="removerItem(idx)" icon="el-icon-delete" type="danger" size="small" plain></el-button>
                        </el-col>
                    </el-row>
                    <el-button @click="adicionarItem" type="primary" size="small" plain>
                        <i class="el-icon-plus"></i> Adicionar item
                    </el-button>
                </c-panel>

                <el-row class="u-mt-15">
                    <el-col :xs="24">
                        <el-form-item label="Situação">
                            <el-switch v-model="dados.situacao" active-text="Ativo" inactive-text="Inativo"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/conceito">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        edit: false,
        grupos: [],
        resultadosConceito: [
            { v: 'aprova', l: 'Aprova' },
            { v: 'conserva', l: 'Conserva (reprova)' }
        ],
        dados: {
            grupo_conceito_id: '',
            descricao: '',
            ordem: 0,
            itens: [],
            situacao: true
        }
    }),
    mounted () {
        this.carregarGrupos()
        if (this.$route.params.id) {
            this.edit = true
            this.carregar(this.$route.params.id)
        } else {
            this.dados.itens = [{ v: '', l: '', resultado: '' }]
        }
    },
    methods: {
        carregarGrupos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/grupo-conceito/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.grupos = r.data || [] })
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/conceito/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                this.dados.grupo_conceito_id = reg.grupo_conceito_id
                this.dados.descricao = reg.descricao
                this.dados.ordem = reg.ordem || 0
                this.dados.itens = Array.isArray(reg.itens) ? reg.itens : []
                this.dados.situacao = !!reg.situacao
                if (!this.dados.itens.length) this.dados.itens = [{ v: '', l: '', resultado: '' }]
            })
        },
        adicionarItem () {
            this.dados.itens.push({ v: '', l: '', resultado: '' })
        },
        removerItem (idx) {
            this.dados.itens.splice(idx, 1)
            if (!this.dados.itens.length) this.dados.itens = [{ v: '', l: '', resultado: '' }]
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) return
                window.eventBus.$emit('loading', true)
                const url = this.edit
                    ? `${this.$store.state.config.baseUrlApi}/api/conceito/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/conceito/store`
                // Limpa itens vazios
                const payload = { ...this.dados, itens: this.dados.itens.filter(i => i.v && i.l) }
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/conceito')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
